<nav [attr.aria-label]="ariaLabel()">
  <div role="list" class="flex flex-wrap items-center gap-4 text-sm tracking-tight text-zinc-300">
    <ng-content></ng-content>
  </div>
</nav>
